import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[onlyDigits]',
})
export class OnlyDigitsDirective {
  @HostListener('input', ['$event']) onInput(event: any) {
    event.target.value = event.target.value.replace(/\D/g, '');
  }
}
